import { render, staticRenderFns } from "./ViewChat.vue?vue&type=template&id=3b570ff9&scoped=true"
import script from "./ViewChat.vue?vue&type=script&lang=js"
export * from "./ViewChat.vue?vue&type=script&lang=js"
import style0 from "./ViewChat.vue?vue&type=style&index=0&id=3b570ff9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b570ff9",
  null
  
)

export default component.exports